import { EntitiesStore } from './entities-store.abstract';

import { HttpClient } from '@angular/common/http';

import { Injector } from '@angular/core';

import { CountryDependencyEntityStore } from './country-dependency-entity-store';
import { tap, mergeMap, map } from 'rxjs/operators';
import { Observable, forkJoin, of } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { FederationAthleteStore } from './federation-athlete-store';
import { WorldRankingStore, IAthlete } from './worldranking-store';
import { AthleteBiographyStore } from './athlete-biography-store';
import { flatten } from 'src/app/officials/components/bootstrap-officials/bootstrap-officials.component';





/**
 * A store for get related athletes.
 *
 * @export
 * @class RelatedAthletesStore
 * @extends {EntitiesStore<IPhotos>}
 */
export class RelatedAthletesStore extends EntitiesStore<IAthlete> {

  /**
   *The athlete ranking for make the request near of world ranking.
   *
   * @type {string}
   * @memberof AthletePhotosStore
   */
  athleteRanking: number;

  /**
   * The athlete country code.
   *
   * @type {string}
   * @memberof RelatedAthletesStore
   */
  athleteCountry: string;

  /**
   * The athlete category.
   *
   * @type {string}
   * @memberof RelatedAthletesStore
   */
  athleteCategory: Array<string>;

  /**
   * The id of athlete for avoid to show himself.
   *
   * @type {string}
   * @memberof RelatedAthletesStore
   */
  athleteId: string;

  /**
   * Store for athletes filtered by country and category before the self athlete.
   *
   * @type {FederationAthleteStore}
   * @memberof RelatedAthletesStore
   */
  athletesStoreBefore: FederationAthleteStore = new FederationAthleteStore(this.http, this.injector);

  /**
   * Store for world ranking filtered by ranking near and before.
   *
   * @memberof RelatedAthletesStore
   */
  worldRankingsStoreBefore = new WorldRankingStore(this.http);

  /**
   * Store for athletes filtered by country and category after the ranking.
   *
   * @type {FederationAthleteStore}
   * @memberof RelatedAthletesStore
   */
  athletesStoreAfter: FederationAthleteStore = new FederationAthleteStore(this.http, this.injector);

  /**
   * Store for world ranking filtered by ranking near and after the ranking
   *
   * @memberof RelatedAthletesStore
   */
  worldRankingsStoreAfter = new WorldRankingStore(this.http);

  constructor(protected http: HttpClient, private injector: Injector) {
    super('null', http);
  }

  /**
   *
   * {@inheritdoc}
   * @returns {Observable<any>}
   * @memberof AthletePhotosStore
   */
  getRequest(params: any, request_more: boolean = false): Observable<any> {
    const RBP = 30;
    const remainder = Math.floor(this.athleteRanking / RBP);
    const lowerRank = remainder + 1;
    const upperRank = remainder === 0 ? 0 : remainder - 1;
    this.loadingRef = true;
    return of([this.athletesStoreBefore, this.worldRankingsStoreBefore, this.worldRankingsStoreAfter]).pipe(mergeMap(
      (a, i) => {
        return forkJoin(...a.map((store, i) => store.requestData({
          CatCode: store instanceof FederationAthleteStore ? undefined : this.athleteCategory[0],
          Detailed: 1,
          Country: store instanceof FederationAthleteStore ? this.athleteCountry : undefined,
          SortBy: 'Ranking',
          RBP: RBP,
          Page: store instanceof WorldRankingStore ?
            (i === 1 ? lowerRank : upperRank) : undefined
        }, false)
        ));
      }
    ), map((a: Array<any>) => {
      const flattenItems = flatten(a.map(value => value.items));
      const MapOfAthletes = flattenItems.reduce((f, s) => {
        return f.set(s.Id ? s.Id : s.Athlete.Id, s.Id ? {
          Id: s.Id,
          FName: s.FName,
          GName: s.GName,
          WNameOrd: s.WNameOrd,
          NOC: s.NOC
        } : s.Athlete);
      }, new Map());
      const arrayOfAthletes = Array.from(MapOfAthletes.values()) as IAthlete[];
      this.data = arrayOfAthletes;
      this.dataStream.next(arrayOfAthletes);
      this.loadingRef = false;
      return arrayOfAthletes.filter(value => value.Id !== this.athleteId)
        .map(n => { return [Math.random(), n] })
        .sort().map((n) => { return n[1] }).slice(0, 15);
    }))
      ;
  }



}
